import React from 'react';
import './SEOContent.css';

const SEOContent = () => (
  <div className="seo-content-section">
    <div className="seo-content-wrapper">
      <h2>Track Official Ireland Visa Decisions From India</h2>
      <div className="seo-intro"><p>
        Our Ireland visa tracker checks publicly available NDVO decision publications
        and matches them against registered visa references. Premium adds email alerts,
        optional browser notifications and 13 planning tools for a one-time ₹349 purchase.
      </p></div>
      <div className="seo-processing-times">
        <h3>Understand Processing Times</h3>
        <p>Processing varies by visa type, office and individual circumstances.
          Check the <a href="https://www.ireland.ie/en/india/newdelhi/services/visas/processing-times-and-decisions/" target="_blank" rel="noopener noreferrer">official New Delhi updates</a>.
          Our <a href="/tools/processing-time">premium processing-time tool</a> provides
          illustrative ranges and dated queue snapshots with their office scope.</p>
      </div>
      <div className="seo-features">
        <h3>What the Service Provides</h3>
        <div className="features-grid">
          <div className="feature-item"><div className="feature-icon">📊</div><div className="feature-content">
            <h4>Official Publication Monitoring</h4>
            <p>We monitor the NDVO decision list. AVATS application handling, VFS passport tracking
              and employment-permit processing are separate systems.</p>
          </div></div>
          <div className="feature-item"><div className="feature-icon">📧</div><div className="feature-content">
            <h4>Decision Notifications</h4>
            <p>Email alerts go to your registered address. Browser notifications are optional
              and require enrollment on each device. Delivery timing varies.</p>
          </div></div>
          <div className="feature-item"><div className="feature-icon">📈</div><div className="feature-content">
            <h4>Historical Decision Context</h4>
            <p>Explore the decisions in our tracked dataset. Aggregate outcomes do not predict
              an individual applicant's result.</p>
          </div></div>
          <div className="feature-item"><div className="feature-icon">🔒</div><div className="feature-content">
            <h4>Clear Data Practices</h4>
            <p>Read our <a href="/privacy">privacy policy</a> to understand account, payment
              and notification data, and how to request deletion.</p>
          </div></div>
          <div className="feature-item"><div className="feature-icon">🛂</div><div className="feature-content">
            <h4>Track Visa Decisions Across Categories</h4>
            <p>We monitor the daily NDVO decision list for applicants from India, including student,
              tourist and Join Family visas, plus Critical Skills and General Employment Permit-related
              outcomes when published. AVATS handling, VFS passport tracking and permit processing
              are separate systems.</p>
          </div></div>
        </div>
      </div>
      <div className="seo-cta-banner">
        <h3>Spend Less Time Checking the Decision List</h3>
        <p>Use automated monitoring alongside official guidance.
          <a href="/pricing"> See the ₹349 premium upgrade</a>.</p>
      </div>
      <div className="seo-footer"><p className="disclaimer">
        <strong>Independent service:</strong> We are not affiliated with the Government of Ireland,
        Irish Immigration, VFS Global or AVATS. Tools and resources provide planning guidance,
        not an official decision or guaranteed outcome.
      </p></div>
    </div>
  </div>
);
export default SEOContent;
